import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import React, { Fragment } from 'react';
import { Query } from 'react-apollo';
import { Link } from 'react-router-dom';
import {
	LINKS_PER_PAGE,
	RandomText,
	Role_Admin,
	Role_DISTRIBUTOR,
	Role_MANUFACTURER,
	Role_STAFF,
	Role_DISTRIBUTOR_STAFF,
	SHOW_PRODUCT_TABLE_WARRANTY,
} from '../../constants';
import QueryHelper from '../../libs/QueryHelper';
import UserProfile from '../auth/UserProfile';
import theme from '../../theme';
import FbEmptyResult from '../common/FbEmptyResult';
import FbError from '../common/FbError';
import FbLoader from '../common/FbLoader';
import Pagination from "../common/Pagination";
import ModelSearch from "../ModelSearch";
import ProductHeaderRow from "./ProductHeaderRow";
import ProductLineDialog from './ProductLineDialog';
import ProductRow from "./ProductRow";
import BulkEnrichDialog from './BulkEnrichDialog';
import Hidden from '@material-ui/core/Hidden';
import _ from 'lodash';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Divider from '@material-ui/core/Divider';


const styles ={
    root: {
        width: '100%',     
        overflowX: 'auto',    
    },
    title: {
        textTransform: "uppercase"
    },
    table: {
       //borderTopWidth: "1px",
       //borderLeftWidth: "1px",
       // borderRightWidth: "1px", 
       // borderColor: theme.palette.common.borderColor
    },
    Grid: {
        backgroundColor: theme.palette.grey[100],
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        minHeight: 49,
        borderLeftWidth: "1px",
        borderRightWidth: "1px",
        borderTopWidth: "1px",
        
        borderColor: theme.palette.common.borderColor,
    },
    lightTooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
    divider: {
        background: "none",
        borderTopWidth: "1px",
        borderStyle:"solid",
        borderColor: theme.palette.common.borderColor,
    },
    paperTable: {
        border: "1px solid", 
        borderColor: theme.palette.common.borderColor,
        minHeight: "calc(100vh - 300px)",
        width: "100%",
        overflowX: 'auto',
        background: theme.palette.common.white,
    },
    filterControl: {
        minWidth: 140,
        marginRight: theme.spacing(1),
        '& .MuiInputBase-root': {
            fontSize: '0.85rem',
        },
    },
    filterLabel: {
        fontSize: '0.8rem',
    },
    filterSelect: {
        padding: '6px 12px',
    },
    filterGroupLabel: {
        fontSize: '0.7rem',
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        color: theme.palette.text.secondary,
        alignSelf: 'center',
    },
    searchGroup: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
    },
    searchGroupLabel: {
        fontSize: '0.7rem',
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        color: theme.palette.text.secondary,
        marginBottom: 2,
    },
    toolbarDivider: {
        width: 1,
        minHeight: 28,
        alignSelf: 'center',
        marginLeft: theme.spacing(0.5),
        marginRight: theme.spacing(0.5),
    },
};

const FooterCell = withStyles(theme => ({
    body: {
        padding: theme.spacing(2),
        borderBottomColor: theme.palette.grey[200],
        fontSize: 14,
        whiteSpace: 'nowrap',
    },
}))(TableCell);
class Product extends React.Component {
    constructor(props) {
        super(props);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleProductTypeFilter = this.handleProductTypeFilter.bind(this);
        this.handleBatteryComponentTypeFilter = this.handleBatteryComponentTypeFilter.bind(this);
        this.handleIsSmartFilter = this.handleIsSmartFilter.bind(this);
        this.state = {
            pageNumber: 1, pageSize: LINKS_PER_PAGE, filter: null, open: false, pLinePageNumber: 1, pLinePageSize: LINKS_PER_PAGE, pLFilter: null, selectedProductId: null, selectedProductLineId:null,random:null,
            scroll: 'paper',
            fullWidth: true,
            maxWidth: 'lg',
            productTypeFilter: '',
            batteryComponentTypeFilter: '',
            isSmartFilter: '',
            bulkEnrichOpen: false,
            currentProducts: [],
        };
        this.onPageChange = this.onPageChange.bind(this);
        this.onDialogShow = this.onDialogShow.bind(this);
        this.onDialogCLose = this.onDialogCLose.bind(this);
        this.notifyUpdate = this.notifyUpdate.bind(this);
        this._getData = this._getData.bind(this);
      
    }

    onPageChange(newPage) {
        this.setState({
            pageNumber: newPage
        })
    }

    onDialogCLose() {
        this.setState({ open: false, selectedProductId: null, selectedProductLineId: null, random: RandomText(8) });
    }

    notifyUpdate(mode,newProductLineId) {
        if (mode === true) {
            this.setState({ selectedProductLineId: null });
        }
        else {
            this.setState({ selectedProductLineId: newProductLineId });
        }
        
    }
    onDialogShow(scroll, model){
        const productLineId = model.productLine != null ? model.productLine.productLineId : null;
        this.setState({ selectedProductLineId: productLineId, selectedProductId: model.productId, open: true, scroll });
    }
    handleSearch(data) {
        this.setState({
            filter: data, pageNumber: 1, pageSize: LINKS_PER_PAGE
        })
    }

    handleProductTypeFilter(event) {
        this.setState({
            productTypeFilter: event.target.value, pageNumber: 1, pageSize: LINKS_PER_PAGE
        })
    }

    handleBatteryComponentTypeFilter(event) {
        this.setState({
            batteryComponentTypeFilter: event.target.value, pageNumber: 1, pageSize: LINKS_PER_PAGE
        })
    }

    handleIsSmartFilter(event) {
        this.setState({
            isSmartFilter: event.target.value, pageNumber: 1, pageSize: LINKS_PER_PAGE
        })
    }

    

    _getQueryVariables(role, manufacturerId) {

        const page = this.state.pageNumber;
        const page_size = this.state.pageSize;
        const skip = (page - 1) * page_size;
        const filter = this.state.filter;
        const first = page_size;
        const random = this.state.random;
        const productType = this.state.productTypeFilter || null;
        const batteryComponentType = this.state.batteryComponentTypeFilter || null;
        const isSmart = this.state.isSmartFilter === '' ? null : this.state.isSmartFilter === 'true';

        switch (role) {
            case Role_Admin: return { manufacturerId:parseInt(manufacturerId), first, skip, filter, productType, batteryComponentType, isSmart };
            case Role_DISTRIBUTOR_STAFF:
            case Role_DISTRIBUTOR: return { manufacturerId: parseInt(manufacturerId), first, skip, filter, productType, batteryComponentType, isSmart };
            case Role_MANUFACTURER:
            case Role_STAFF:
            default: return { first, skip, filter, random, productType, batteryComponentType, isSmart };
        }
            
    }


    shouldComponentUpdate(nextProps, nextState) {
        
        let shouldUpdate = (this.state.pageNumber !== nextState.pageNumber || this.state.pageSize !== nextState.pageSize ||
            this.state.filter !== nextState.filter || this.state.open !== nextState.open ||
            this.state.selectedProductLineId !== nextState.selectedProductLineId || this.props.manufacturerId !== nextProps.manufacturerId ||
            this.state.productTypeFilter !== nextState.productTypeFilter || this.state.batteryComponentTypeFilter !== nextState.batteryComponentTypeFilter ||
            this.state.isSmartFilter !== nextState.isSmartFilter)
        return shouldUpdate;
    }

    _getData(data, role) {
        //adminView ? data.admin.products : data.productfeed.products
        switch (role) {
            case Role_Admin: return { productCount: data.admin.count, products: data.admin.products };
            case Role_DISTRIBUTOR_STAFF:
            case Role_DISTRIBUTOR: return { productCount: data.supplier.count, products: data.supplier.products };
            case Role_MANUFACTURER:
            case Role_STAFF:
            default: return { productCount: data.productfeed.count, products: data.productfeed.products }; 
        }
    }
    render() {
       
        const { classes } = this.props;
        let { manufacturerId } = this.props;
        const role = UserProfile.getRole();
        const { open, selectedProductId, selectedProductLineId } = this.state;
        const query = QueryHelper().ProductListing();
        const isDistributor = UserProfile.isDistributor();
        const canManageProducts =
            !isDistributor && (role === Role_MANUFACTURER || role === Role_STAFF);
        const canAddModelCode =
            canManageProducts ||
            (isDistributor && !_.isNil(manufacturerId));
        const tableColSpan = (role === Role_Admin ? 9 : 10) - (SHOW_PRODUCT_TABLE_WARRANTY ? 0 : 2);
      
        return (
          
            
                    <Fragment>
                    
                        <Grid 
                            container
                            direction="row"
                            justify="space-between"
                            alignItems="center"
                            className={classes.Grid}
                        >
                            <Grid item>
                                {canManageProducts && (
                                    <Fragment>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            component={Link}
                                            to="/addproductmodel"
                                            style={{ marginRight: theme.spacing(1) }}
                                        >
                                            Add product
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            size="small"
                                            component={Link}
                                            to="/importproducts"
                                        >
                                            Bulk import
                                        </Button>
                                    </Fragment>
                                )}
                            </Grid>
                            <Grid item>
                                <Grid
                                    container
                                    direction="row"
                                    alignItems="center"
                                    spacing={1}
                                    wrap="wrap"
                                >
                                    <Grid item>
                                        <Typography component="span" className={classes.filterGroupLabel}>
                                            Filters
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        <FormControl variant="outlined" size="small" className={classes.filterControl}>
                                            <InputLabel className={classes.filterLabel}>Product Type</InputLabel>
                                            <Select
                                                value={this.state.productTypeFilter}
                                                onChange={this.handleProductTypeFilter}
                                                label="Product Type"
                                                classes={{ root: classes.filterSelect }}
                                            >
                                                <MenuItem value="">All</MenuItem>
                                                <MenuItem value="BATTERY">Battery</MenuItem>
                                                <MenuItem value="INVERTER">Inverter</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item>
                                        <FormControl variant="outlined" size="small" className={classes.filterControl}>
                                            <InputLabel className={classes.filterLabel}>Component Type</InputLabel>
                                            <Select
                                                value={this.state.batteryComponentTypeFilter}
                                                onChange={this.handleBatteryComponentTypeFilter}
                                                label="Component Type"
                                                classes={{ root: classes.filterSelect }}
                                            >
                                                <MenuItem value="">All</MenuItem>
                                                <MenuItem value="MODULAR">Modular</MenuItem>
                                                <MenuItem value="MASTER">Master</MenuItem>
                                                <MenuItem value="STANDALONE">Standalone</MenuItem>
                                                <MenuItem value="INVERTER_CONTROLLER">Inverter controller</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item>
                                        <FormControl variant="outlined" size="small" className={classes.filterControl}>
                                            <InputLabel className={classes.filterLabel}>Is Smart</InputLabel>
                                            <Select
                                                value={this.state.isSmartFilter}
                                                onChange={this.handleIsSmartFilter}
                                                label="Is Smart"
                                                classes={{ root: classes.filterSelect }}
                                            >
                                                <MenuItem value="">All</MenuItem>
                                                <MenuItem value="true">Yes</MenuItem>
                                                <MenuItem value="false">No</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    {canAddModelCode && (
                                        <Grid item>
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                size="small"
                                                component={Link}
                                                to="/addproductmodel"
                                            >
                                                + Add Model Code
                                            </Button>
                                        </Grid>
                                    )}
                                    {role === Role_Admin && (
                                        <Grid item>
                                            <Divider orientation="vertical" className={classes.toolbarDivider} />
                                        </Grid>
                                    )}
                                    {role === Role_Admin && (
                                        <Grid item>
                                            <Button
                                                variant="outlined"
                                                color="secondary"
                                                size="small"
                                                onClick={() => this.setState({ bulkEnrichOpen: true })}
                                            >
                                                Bulk AI Enrich
                                            </Button>
                                        </Grid>
                                    )}
                                    <Grid item>
                                        <Divider orientation="vertical" className={classes.toolbarDivider} />
                                    </Grid>
                                    <Grid item>
                                        <div className={classes.searchGroup}>
                                            <Typography component="span" className={classes.searchGroupLabel}>
                                                Search
                                            </Typography>
                                            <ModelSearch filterText={this.state.filter} searchHandler={this.handleSearch} />
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <div className={classes.root}>
                            <Paper elevation={0} square classes={{ root: classes.paperTable }}>
                                <Table className={classes.table}>
                                    <Hidden smDown>
                                        <TableHead>
                                            <ProductHeaderRow
												adminView={UserProfile.isAdmin()}
												showWarranty={SHOW_PRODUCT_TABLE_WARRANTY}
											/>
                                        </TableHead>
                                    </Hidden>
                            {isDistributor && (_.isNil(manufacturerId)) && <tbody><tr><td colSpan={tableColSpan} style={{ "textAlign": "center" , "padding" : "20px" }}><Typography justify="center" align="center" component="span"
                                        alignItems="center" >Please contact manufacturer to activate account </Typography></td></tr></tbody>
                                    }
                            {((isDistributor && !_.isNil(manufacturerId)) || (!isDistributor)) &&

                                (<Query query={query} variables={this._getQueryVariables(role, manufacturerId)} fetchPolicy="no-cache">
                                            {({ loading, error, data }) => {


                                                if (loading) return <FbLoader isTableBodyRequired={true} colSpan={tableColSpan} loaderStyle={'emptycell'} />
                                                if (error) return <FbError isTableBodyRequired={true} colSpan={tableColSpan} errorStyle={'emptycell'} />
                                                const { productCount, products } = this._getData(data, role);
                                                if (role === Role_Admin && products && products !== this.state.currentProducts) {
                                                    setTimeout(() => this.setState({ currentProducts: products }), 0);
                                                }
                                                const paging = (<Pagination Prefix="products" TotalRecords={productCount} PageSize={this.state.pageSize} PageNumber={this.state.pageNumber} ShowPreviousNext={true} onPageChange={this.onPageChange} ></Pagination>);
                                                const listModels = products.map((model, index) =>
                                                    (
                                                        <ProductRow
															key={index}
															role={role}
															isDistributor={isDistributor}
															adminView={role === Role_Admin ? true : null}
															model={model}
															index={index}
															shouldOpenDialog={this.onDialogShow}
															showWarranty={SHOW_PRODUCT_TABLE_WARRANTY}
														/>

                                                    ));
                                                const result = (products !== 'undefined' && products.length > 0) ? listModels : <FbEmptyResult isTableBodyRequired={false} colSpan={tableColSpan} errorStyle={'emptycell'} />;
                                                const pagination_content = (products !== 'undefined' && products.length > 0 && productCount > this.state.pageSize) ? <TableFooter ><TableRow ><FooterCell colSpan={String(tableColSpan)}>{paging}</FooterCell ></TableRow ></TableFooter > : null;
                                                return (<Fragment><TableBody>{result}</TableBody>{pagination_content}</Fragment>);
                                            }}
                                        </Query>)
                                    }

                                </Table>
                            </Paper>
                        </div>
                        <ProductLineDialog open={open} handleClose={this.onDialogCLose} selectedProductId={selectedProductId} selectedProductLineId={selectedProductLineId} notifyUpdate={this.notifyUpdate} />
                        {role === Role_Admin && (
                            <BulkEnrichDialog
                                open={this.state.bulkEnrichOpen}
                                onClose={() => this.setState({ bulkEnrichOpen: false })}
                                products={this.state.currentProducts || []}
                            />
                        )}
                    </Fragment>
        )
    }
                  
       
        
    
}

export default withStyles(styles)(Product);   
